import React, { type ReactNode } from 'react';

interface Props {
  title: string;
  isMobileTitleHidden?: boolean;
  action?: ReactNode;
  children: ReactNode;
}

export const LessonDetailsSection: React.FC<Props> = ({
  title,
  isMobileTitleHidden = false,
  action,
  children,
}) => (
  <section className="flex flex-col gap-3">
    <div
      className={`flex items-center justify-between gap-3 ${isMobileTitleHidden ? 'max-md:hidden' : ''}`}
    >
      <h3 className="text-callout-16 min-w-0 text-foreground">{title}</h3>
      {action}
    </div>
    {children}
  </section>
);
